var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReconciliation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.625C4.825 0.625 0.625 4.825 0.625 10C0.625 15.175 4.825 19.375 10 19.375C15.175 19.375 19.375 15.175 19.375 10C19.375 4.825 15.175 0.625 10 0.625ZM10.8333 14.1667H9.16667V12.5H10.8333V14.1667ZM10.8333 10.8333H9.16667V5.83333H10.8333V10.8333Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 7.5L7.5 9.16667L10 6.66667L12.5 9.16667L14.1667 7.5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReconciliation);
export default __webpack_public_path__ + "static/media/reconciliation.382b7050b0a36b680d8516648f221371.svg";
export { ForwardRef as ReactComponent };